import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.showNotification),callback:function ($$v) {_vm.showNotification=$$v},expression:"showNotification"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c(VBtn,{attrs:{"dark":"","text":""},nativeOn:{"click":function($event){_vm.showNotification = false}}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }